export default __webpack_public_path__ + "static/lgbtq-belmond-1-6eaca247298b4d6a0faf0c4c035c6244.jpg";